let scrollAnimationObserver;

function isElementInView(element) {
  const rect = element.getBoundingClientRect();
  return rect.top <= window.innerHeight - 100 && rect.bottom >= 0;
}

function initializeScrollAnimations() {
  const scrollElements = document.querySelectorAll('.hero-content,.cta-section,.grid-section,.two-column-section,.team-section,.logo-carousel-section,.latest-content-section,.scroll-animate');
  if (!scrollElements.length) return;

  if (!scrollAnimationObserver) {
    scrollAnimationObserver = new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) target.classList.add('scroll-animate-visible');
      });
    }, { rootMargin: '0px 0px -100px', threshold: .1 });
  }

  scrollElements.forEach(element => {
    element.classList.add('scroll-animate');
    scrollAnimationObserver.observe(element);

    if (isElementInView(element)) {
      element.classList.add('scroll-animate-visible');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimations();
});

window.initializeScrollAnimations = initializeScrollAnimations;
